import isTouchSupported from '../../../helpers/isTouchSupported';

interface InitMiniAccount {
  initMiniAccountTouchHoverEvents: (isXLargeUp: boolean) => void;
  cleanUpMiniAccountOnViewportResize: () => void;
}

const HIDE_VISIBILITY_CLASS = 'hide-visibility';

function initMiniAccount(): InitMiniAccount {
  const miniAccountRootElement = document.querySelector<HTMLLIElement>('.page-header__icons-item--account');
  const miniAccountLinkElement = miniAccountRootElement?.querySelector<HTMLAnchorElement>(
    '.page-header__icons-item-link'
  );
  const miniAccountElement = miniAccountRootElement?.querySelector<HTMLDivElement>('.mini-account');

  function showMiniAccount(): void {
    miniAccountElement?.classList.remove(HIDE_VISIBILITY_CLASS);
  }

  function hideMiniAccount(): void {
    miniAccountElement?.classList.add(HIDE_VISIBILITY_CLASS);
  }

  function miniAccountHoverHandler(): void {
    if (miniAccountElement?.classList.contains(HIDE_VISIBILITY_CLASS)) {
      showMiniAccount();
      document.addEventListener('mousemove', function hideOnOutsideHover(event: MouseEvent) {
        if ((event.target as Element).closest('.page-header__icons-item--account') === null) {
          hideMiniAccount();
          document.removeEventListener('mousemove', hideOnOutsideHover);
        }
      });
    }
  }

  function miniAccountTouchHandler(e: TouchEvent): void {
    if (e.touches.length === 1 && miniAccountElement?.classList.contains(HIDE_VISIBILITY_CLASS)) {
      e.preventDefault();
      showMiniAccount();
      document.addEventListener(
        'touchstart',
        function hideOnOutsideTouch(event: TouchEvent) {
          if ((event.target as HTMLElement).closest('.page-header__icons-item--account') === null) {
            event.stopPropagation();
            event.preventDefault();
            hideMiniAccount();
            document.removeEventListener('touchstart', hideOnOutsideTouch);
          }
        },
        { passive: false }
      );
    }
  }

  function initMiniAccountTouchHoverEvents(isXLargeUp: boolean): void {
    const isLoggedIn = miniAccountRootElement?.classList.contains('page-header__icons-item--account-logged-in');
    if (isLoggedIn && isXLargeUp) {
      miniAccountLinkElement?.addEventListener('mouseover', miniAccountHoverHandler);
      if (isTouchSupported()) {
        miniAccountLinkElement?.addEventListener('touchstart', miniAccountTouchHandler);
      }
    } else if (isLoggedIn) {
      miniAccountLinkElement?.removeEventListener('mouseover', miniAccountHoverHandler);
      if (isTouchSupported()) {
        miniAccountLinkElement?.removeEventListener('touchstart', miniAccountTouchHandler);
      }
    }
  }

  function cleanUpMiniAccountOnViewportResize(): void {
    hideMiniAccount();
  }

  return { initMiniAccountTouchHoverEvents, cleanUpMiniAccountOnViewportResize };
}

export default initMiniAccount;
